<template>
  <!-- content -->
  <div class="content--block">
    <div class="custom-content--header-min">
      <div class="custom-content--header-min-container">
        <h1 class="custom-content--header-min-heading">Tpp certificate</h1>
      </div>
      <p class="content--block-wrapper-description">
        Tpp certificate is needed to perform API calls outside of the
        portal
      </p>
    </div>

    <div class="custom-content--header-min">
      <div class="tpp-block">
        <div v-if="certificates" class="tpp-content">
          <div>
            <textarea id="certificate" v-html="$options.filters.removeNewLines(certificates.certificate)"/>
            <div class="action-button">
              <ul class="custom-content--file-list-container">
                <input type="hidden" class="file-list-count" name="file-list-count" value="1">
                <li class="custom-content--file-list-item">
                  <div class="custom-content--file-list-item-content">
                    <div class="custom-content--file-list-item-content-icon">
                      <div class="custom-content--file-list-item-content-icon-border"></div>
                      <a href="#">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          class
                        >
                          <path
                            d="M13.5 10.58H16v3.94c0 .82-.67 1.48-1.5 1.48h-13C.67 16 0 15.34 0 14.52v-3.94h2.5v2.96h11zM6.5 0v6.4H4.51a.26.26 0 0 0-.25.13c-.04.09-.03.2.04.28l3.41 4.61c.07.09.17.15.29.15.12 0 .23-.06.3-.15l3.4-4.61a.23.23 0 0 0 .03-.27.24.24 0 0 0-.24-.14H9.5V0z"
                          ></path>
                        </svg>
                      </a>
                    </div>
                    <a download="tpp.crt" :href="certificateData">
                      <h2 class="custom-content--file-list-item-content-text">Download certificate</h2>
                    </a>
                  </div>
                  <div class="copy-link">
                    <a
                      href="#"
                      class="custom-content--cta-button"
                      v-on:click.prevent="copyCertificate()"
                    >
                      <p>Copy</p>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <textarea id="privateKey" v-html="$options.filters.removeNewLines(certificates.privateKey)"/>
            <div class="action-button">
              <ul class="custom-content--file-list-container">
                <input type="hidden" class="file-list-count" name="file-list-count" value="1">
                <li class="custom-content--file-list-item">
                  <div class="custom-content--file-list-item-content">
                    <div class="custom-content--file-list-item-content-icon">
                      <div class="custom-content--file-list-item-content-icon-border"></div>
                      <a href="#">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          class
                        >
                          <path
                            d="M13.5 10.58H16v3.94c0 .82-.67 1.48-1.5 1.48h-13C.67 16 0 15.34 0 14.52v-3.94h2.5v2.96h11zM6.5 0v6.4H4.51a.26.26 0 0 0-.25.13c-.04.09-.03.2.04.28l3.41 4.61c.07.09.17.15.29.15.12 0 .23-.06.3-.15l3.4-4.61a.23.23 0 0 0 .03-.27.24.24 0 0 0-.24-.14H9.5V0z"
                          ></path>
                        </svg>
                      </a>
                    </div>
                    <a download="tpp_private.key" :href="privateKeyData">
                      <h2 class="custom-content--file-list-item-content-text">Download key</h2>
                    </a>
                  </div>
                  <div class="copy-link">
                    <a
                      href="#"
                      class="custom-content--cta-button"
                      v-on:click.prevent="copyPrivateKey()"
                    >
                      <p>Copy</p>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="loading" id="loadingDiv" class="custom-content--header-min api-content">
          <div class="wait">
            <div class="wait--preloader">
              <svg
                xmlns:svg="http://www.w3.org/2000/svg"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.0"
                width="64px"
                height="64px"
                viewBox="0 0 128 128"
                xml:space="preserve"
                class
              >
                <g transform="rotate(276.875 64 64)">
                  <path
                    d="M0.00765413755,65 C0.00255755226,64.6672764 0,64.3339369 0,64 C0,28.653776 28.653776,0 64,0 C99.346224,0 128,28.653776 128,64 C128,99.346224 99.346224,128 64,128 L64,118 C93.8233765,118 118,93.8233765 118,64 C118,34.1766235 93.8233765,10 64,10 C34.1766235,10 10,34.1766235 10,64 C10,64.3340505 10.0030332,64.6673925 10.0090737,65 L0.00765413755,65 Z"
                    fill-opacity="1"
                  ></path>
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 64 64"
                    to="360 64 64"
                    dur="1800ms"
                    repeatCount="indefinite"
                  ></animateTransform>
                </g>
              </svg>
            </div>
          </div>
        </div>
        <div>
          <a
            href="#"
            class="custom-content--cta-button"
            v-if="!loading"
            v-on:click.prevent="generateNewCertificate()"
          >
            <p>Generate new certificate</p>
          </a>
        </div>
      </div>
    </div>
  </div>
  <!--/. content -->
</template>
<script>
import * as api from "../modules/api.js";
var me;
export default {
  data: function() {
    return {
      certificates: null,
      loading: false
    };
  },
  methods: {
    copyCertificate: function() {
      me.toClipboard($("#certificate"));
      me.$store.dispatch("notify", {
        type: "success",
        message: "Certificate data copied to clipboard"
      });
    },
    copyPrivateKey: function() {
      me.toClipboard($("#privateKey"));
      me.$store.dispatch("notify", {
        type: "success",
        message: "Private key data copied to clipboard"
      });
    },
    toClipboard(element) {
      element.select();
      document.execCommand("copy");
    },
    generateNewCertificate() {
      me.loading = true;
      me.certificates = null;
      api.request(api.generateCertificates).then(function(value) {
        me.loading = false;
        me.certificates = value;
      });
    }
  },
  filters: {
    removeNewLines: function (value) {
      if (!value) return '';
      var start = value.indexOf('---\r\n') + 4;
      var end = value.indexOf('\r\n---');
      return value.substring(0, start + 4) + value.substring(start,end).replace(/(\r\n|\n|\r)/gm,'') + value.substring(end);
    }
  },
  mounted() {
    me = this;

    me.loading = true;
    api.request(api.certificates).then(function(value) {
      me.loading = false;
      me.certificates = value;
    });
  },
  computed: {
    certificateData() {
      return "data:text/plain;base64," + btoa(me.certificates.certificate);
    },
    privateKeyData() {
      return "data:text/plain;base64," + btoa(me.certificates.privateKey);
    }
  },
  updated: function() {
    this.$nextTick(function() {
      if (me.certificates) {
        $(".tpp-content")
          .on("change keyup keydown paste cut", "textarea", function() {
            $(this)
              .height(0)
              .height(this.scrollHeight);
          })
          .find("textarea")
          .change();
      }
    });
  }
};
</script>